import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box } from "@mui/material";

import logo from "../logos-ex.png";

const LeftHeader = React.memo(() => {
  return (
    <Box
      component={RouterLink}
      to="/"
      sx={{
        display: "flex",
        alignItems: "center",
        color: "inherit",
        textDecoration: "none",
        flexShrink: 0,
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="Logo"
        sx={{
          height: { xs: 36, sm: 48, md: 56 },
          width: "auto",
          userSelect: "none",
          WebkitUserDrag: "none",
        }}
      />
    </Box>
  );
});

export default LeftHeader;
